import React from 'react';
import { FormattedMessage } from 'react-intl';

import FormKeys from 'modules/form/types/FormKeys';
import { getAdvicesFunctions } from 'components/Advices';

import List from './List';
import TotalLine from './TotalLine';
import RepairOrderList from './RepairOrderList';
import useBasketItems from '../useBasketItems';
import useBasketTotals from '../useBasketTotals';

const Content: React.FC = () => {
  const {
    repairOrderItems, acceptedExtras, acceptedProactiveWorks, hasData, onRemoveExtra, onRemoveProactiveWork,
  } = useBasketItems();

  const {
    vat, totalExclTax, totalTax, total, hiddenRepairOrderPrices,
  } = useBasketTotals({ extras: acceptedExtras, proactiveWorks: acceptedProactiveWorks, repairOrderItems });

  return (
    <div className="flex flex-col !pt-0">
      {!hasData && (
        <span className="text-center text-default italic text-xs" data-testid="empty-basket">
          <FormattedMessage
            id="basket.empty"
            defaultMessage="Your basket is empty"
          />
        </span>
      )}
      {hasData && (
        <div>
          {repairOrderItems.length > 0 && (<RepairOrderList items={repairOrderItems} />)}
          {acceptedProactiveWorks.length > 0 && (
            <List
              items={acceptedProactiveWorks}
              onRemove={onRemoveProactiveWork}
              getAdvices={getAdvicesFunctions[FormKeys.REPAIR_ORDER]}
              title={<FormattedMessage id="proactiveWorks.title" defaultMessage="Proactive work" />}
            />
          )}
          {acceptedExtras.length > 0 && (
            <List
              items={acceptedExtras}
              onRemove={onRemoveExtra}
              getAdvices={getAdvicesFunctions[FormKeys.EXTRAS]}
              title={<FormattedMessage id="basket.total.extras" defaultMessage="Check-in extras" />}
            />
          )}
          <div className="h-px w-full bg-neutral-blue-100 my-l" />
          <TotalLine
            price={totalExclTax}
            className="!text-default font-semibold"
            showHiddenPriceWarning={hiddenRepairOrderPrices}
            title={<FormattedMessage id="basket.total.exclTax" defaultMessage="Total (excl. tax)" />}
          />
          <TotalLine
            price={totalTax}
            className="!text-default font-semibold"
            showHiddenPriceWarning={hiddenRepairOrderPrices}
            title={<FormattedMessage id="basket.total.tax" defaultMessage="Tax ({vat}%)" values={{ vat }} />}
          />
          <TotalLine
            price={total}
            className="!text-default !text-s font-bold mt-3xs"
            showHiddenPriceWarning={hiddenRepairOrderPrices}
            title={hiddenRepairOrderPrices
              ? <FormattedMessage id="basket.total.title" defaultMessage="Total" />
              : <FormattedMessage id="basket.total.inclTax" defaultMessage="Total (incl. tax)" />}
          />
          <p className="text-center text-xs mt-l">
            <FormattedMessage
              id="basket.modal.disclaimer"

              defaultMessage="Items without price do not indicate they will be provided free of charge. Their final price has not yet been set, will be determined later and communicated to you accordingly. The total amount may be impacted."
            />
          </p>
        </div>
      )}
    </div>
  );
};

export default Content;
